import React from 'react';

const HeroSection = ({ backgroundImage, title }) => {
  return (
    <section className="relative overflow-hidden transition-all h-[60vh] md:h-[80vh] lg:h-[50vh] bg-cover bg-center" style={{backgroundImage: `url(${backgroundImage})`}}>
        <div className="absolute inset-0 bg-[#1F0707] opacity-40"></div>
        <div className="relative z-10 flex items-center justify-center w-full h-full">
            <h1 className="text-white text-4xl md:text-5xl font-medium font-libre-caslon text-center">{title}</h1>
        </div>
    </section>
  );
};

export default HeroSection;
